import { HOST, PATH_BACKSTAGE } from "@components/Constants";

const PLACEHOLDER_SUBJECT = "<correlation-id>";
const PLACEHOLDER_EMAIL = "<email>";

type Props = {
  email?: string;
  domain?: string;
  issuer: string;
  publicKeyId: string;
  correlationId?: string;
};

// NOTE: the client calls the API on the domain of the organization. An
//       organization with no domain of its own uses the host of this app.
const getHost = (domain?: string): string => {
  const hasDomain = !!domain;

  if (!hasDomain) {
    return HOST;
  }

  return `https://${domain}`;
};

const getIdTokenSnippet = ({
  email,
  domain,
  issuer,
  publicKeyId,
  correlationId,
}: Props): string => {
  const host = getHost(domain);
  const subject = correlationId || PLACEHOLDER_SUBJECT;
  const subjectEmail = email || PLACEHOLDER_EMAIL;

  const snippet = `import jwt from "jsonwebtoken";

// Your private key that pairs with this public key. Keep it secret.
const privateKey = process.env.FUNDAMENTAL_PRIVATE_KEY;

// The sub claim gives your account, and the email claim gives your email.
const idToken = jwt.sign(
  {
    sub: "${subject}",
    email: "${subjectEmail}",
  },
  privateKey,
  {
    algorithm: "RS256",
    issuer: "${issuer}",
    keyid: "${publicKeyId}",
    expiresIn: "5m",
  },
);

const HOST = "${host}";

// Step 1: exchange the ID token for the authentication token.
const authenticateResponse = await fetch(\`\${HOST}/api/identity/Authenticate\`, {
  method: "PATCH",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    idToken,
    redirectUrl: \`\${HOST}${PATH_BACKSTAGE}\`,
  }),
});

const { data: identity } = await authenticateResponse.json();
const { authenticationJwt } = identity;

// Step 2: exchange the authentication token for the authorization token.
const authorizeResponse = await fetch(\`\${HOST}/api/backstage/Authorize\`, {
  method: "PATCH",
  headers: { authentication: authenticationJwt },
});

const { data: user } = await authorizeResponse.json();
const { authorizationJwt } = user;

// Step 3: put the authorization token into the authorization header.
const response = await fetch(\`\${HOST}/api/backstage/IndexUsers\`, {
  method: "GET",
  headers: { authorization: authorizationJwt },
});
`;

  return snippet;
};

export default getIdTokenSnippet;
